// Quinnipiac University's undergraduate majors. Read on 2026-10-01 from the
// official 2026-2027 Academic Catalog's Programs table (catalog.qu.edu/programs/),
// which lists each program with its department, college or school, academic
// level and degree type. Kept: every row at the Undergraduate level whose
// degree type is a bachelor's, plus the accelerated second-degree nursing
// BSN (marked). Left out: minors, certificates, badges, graduate programs and
// the dual-degree and accelerated dual-degree bachelor's/graduate rows. The
// degree is the catalog's own wording ("Bachelor of Science"); the
// catalog's school labels ("Arts & Sciences") are written out as the
// college or school name. The Health Science Studies and Industrial
// Engineering double degree sits with Health Sciences, its first school in
// the catalog. Official names kept as written, including "Applied AI and
// Business Analytics". The KB's majors list was the starting point; the
// catalog wins.
const majors = {
    "slug": "quinnipiac-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Quinnipiac's official 2026-2027 Academic Catalog, grouped by the college or school that offers it, with the degree it leads to. Minors, certificates, graduate programs and dual-degree bachelor's and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "Quinnipiac 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.qu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Behavioral Neuroscience",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biochemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Chemistry",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Criminal Justice",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Data Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Economics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "English",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Policy and Sustainability",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Environmental Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Environmental Studies (co-major)",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Forensic Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Game Design and Development",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Health, Medicine, and Society",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Hispanic and Latin American Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "History",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Individualized Major",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Interdisciplinary Studies/Concentration in Education Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Justice and Community Engagement",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Law in Society",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Mathematics",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Philosophy",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Political Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Professional Studies",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Psychology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sociology",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "School of Business",
            "source": {
                "label": "Quinnipiac 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.qu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Applied AI and Business Analytics",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Applied Business",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Biomedical Marketing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Business Administration (degree completion)",
                    "degree": "Bachelor of Business Administration"
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Information Systems and Accounting",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Entrepreneurship and Innovation",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Finance",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Financial Technology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Human Resource Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "International Business",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Marketing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Sport and Entertainment Management",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Communications",
            "source": {
                "label": "Quinnipiac 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.qu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Advertising and Integrated Communications",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Communications",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Film, Television and Media Arts",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Film, Television and Media Arts",
                    "degree": "Bachelor of Fine Arts"
                },
                {
                    "name": "Graphic and Interactive Design",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Journalism",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Public Relations",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Sports Communications",
                    "degree": "Bachelor of Arts"
                }
            ]
        },
        {
            "name": "School of Computing and Engineering",
            "source": {
                "label": "Quinnipiac 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.qu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Artificial Intelligence and Computing",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Arts"
                },
                {
                    "name": "Computer Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Software Engineering",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Health Sciences",
            "source": {
                "label": "Quinnipiac 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.qu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Biomedical Sciences",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Diagnostic Medical Sonography",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Exercise Science",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Health Science Studies",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Health Science Studies - Online BS Degree Completion",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Health Science Studies and Industrial Engineering",
                    "degree": "Bachelor of Science (Double Degree)",
                    "note": "A double degree with the School of Computing and Engineering."
                },
                {
                    "name": "Medical Microbiology and Immunology",
                    "degree": "Bachelor of Science"
                },
                {
                    "name": "Radiologic Sciences",
                    "degree": "Bachelor of Science"
                }
            ]
        },
        {
            "name": "School of Nursing",
            "source": {
                "label": "Quinnipiac 2026-2027 Academic Catalog, Programs",
                "url": "https://catalog.qu.edu/programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "Bachelor of Science in Nursing"
                },
                {
                    "name": "Nursing (Hartford HealthCare)",
                    "degree": "Bachelor of Science in Nursing"
                },
                {
                    "name": "Nursing (second degree)",
                    "degree": "Bachelor of Science in Nursing",
                    "note": "An accelerated program for students who already hold a bachelor's degree."
                }
            ]
        }
    ]
};

export default majors;
